import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { LONG_TERM_GROWTH_RATE, TERMINAL_VALUE, WACC } from 'pages/Valuations/util/constants';
import { confirmNoValue } from 'utilities/confirmNoValue';

const GROWTH_FEEDBACK = 'Long-term growth rate must be lower than WACC.';

interface GrowthValidationParams {
  parsedColumns: Record<string, ICell>;
  addFeedbackFromCell: (cell: ICell, feedback: string) => void;
  removeFeedbackFromCell: (cell: ICell, feedback: string) => void;
}

const validateGrowth =
  (method: string) =>
    ({ parsedColumns, addFeedbackFromCell, removeFeedbackFromCell }: GrowthValidationParams) => {
      const cells = Object.values(parsedColumns);
      const growth = cells.find(cell => cell.alias === LONG_TERM_GROWTH_RATE);
      const wacc = cells.find(cell => cell.alias === WACC);
      const selectedMethod = cells.find(cell => cell.alias === TERMINAL_VALUE)?.value;
      if (!growth || !wacc) {
        return;
      }

      if (
        selectedMethod === method &&
      !confirmNoValue(growth.value) &&
      !confirmNoValue(wacc.value) &&
      Number(growth.value) >= Number(wacc.value)
      ) {
        addFeedbackFromCell(growth, GROWTH_FEEDBACK);
      } else {
        removeFeedbackFromCell(growth, GROWTH_FEEDBACK);
      }
    };

export default validateGrowth;
